import {z} from "zod/v4-mini"
import {registerTemplateGraphNode, getTemplateNodeReturns, externalId} from "@cm/template-nodes"
import type {TemplateNodeDefinition} from "@cm/template-nodes"
import {MattressExport, type MattressExportParameters} from "#mattress/nodes/mattress-export"
import {mattressReferenceFrameLike} from "#mattress/validation"
import type {MattressReferenceFrameLikeNode} from "#mattress/role-markers"
import {MattressReferenceFrameInfo} from "#mattress/nodes/component/mattress-component-interface-descriptors"

export type MattressReferenceFrameExportParameters = MattressExportParameters<MattressReferenceFrameLikeNode>

const definition: TemplateNodeDefinition<MattressReferenceFrameExportParameters> = {
    nodeClass: "MattressReferenceFrameExport",
    validation: {
        parameters: z.object({
            name: z.string(),
            id: externalId,
            node: z.nullable(mattressReferenceFrameLike),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MattressReferenceFrameExport extends MattressExport<MattressReferenceFrameLikeNode> {
    public override get definition() {
        return definition
    }

    protected override get outputType() {
        return "mattressReferenceFrame" as const
    }

    protected override get InfoClass() {
        return MattressReferenceFrameInfo
    }
}
